import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { OrganisationAdminApiService } from 'src/modules/role/organisation-admin/services/organisation-admin-api-service';

@Component({
    selector: 'edit-organisations',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class EditOrganisations implements OnInit {
  @Input() role: string;
  @Input() userId: number;
  public filteredOrgs: any = [];
  public userOrgs = new BehaviorSubject<Array<IOrganisation>>([]);
  myControl = new FormControl('');

  constructor(
    private OrganisationAdminApi: OrganisationAdminApiService,
    private ActivatedRoute: ActivatedRoute
  ) {}

  debounce(func, wait) {
    let timeout;

    return (...args) => {
      const later = () => {
        timeout = null;
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  ngOnInit(): void {
    this.getUserOrgs(null);
    this.setFilteredOrgs();
  }

  setFilteredOrgs() {
    this.myControl.valueChanges.subscribe((value) => {
      if (value && value.length > 2) {
        this.filterOptionsDebounce(value);
      }
    });
  }

  filterOptionsDebounce = this.debounce(this.filterOptions.bind(this), 300);

  async filterOptions(value) {
    const values = await this.OrganisationAdminApi.getFilteredOrgs(
      { searchString: value },
      this.role
    );
    if (values && values.data) {
      this.filteredOrgs = values.data.filter((org: IOrganisation) => {
        return !this.userOrgs.value.some((userOrg) => {
          return userOrg.company_id === org.id;
        });
      });
    }
  }

  async getUserOrgs(PageEvent: PageEvent) {
    const data = await this.OrganisationAdminApi.getOrgs(
      this.userId,
      '',
      null,
      this.role
    );
    this.userOrgs.next(data.data);
    this.setFilteredOrgs();
  }

  async deleteItem(org) {
    const { company_id } = org;
    await this.OrganisationAdminApi.delete(company_id, this.userId, this.role);
    this.getUserOrgs(null);
  }

  async updateOrgs(organisation) {
    const selectedOrg = organisation.option.value;

    const options = { userId: this.userId, organisation: selectedOrg };
    await this.OrganisationAdminApi.addUserToOrganisation(options, this.role);
    this.myControl.setValue(null);
    this.getUserOrgs(null);
  }

  displayOption(option) {
    return option && option.title ? option.title : '';
  }

  onSubmit() {}
}
